// Closest ancestor that scrolls vertically (`overflow-y: auto | scroll`), or null.
export const findScrollParent = (element: HTMLElement) => {
    let parent = element.parentElement;

    while (parent) {
        const {overflowY} = getComputedStyle(parent);

        if (overflowY === "auto" || overflowY === "scroll") return parent;

        parent = parent.parentElement;
    }

    return null;
};
// Closest ancestor that scrolls vertically (`overflow-y: auto | scroll`), or null.
export const findScrollParent = (element: HTMLElement) => {
    let parent = element.parentElement;

    while (parent) {
        const {overflowY} = getComputedStyle(parent);

        if (overflowY === "auto" || overflowY === "scroll") return parent;

        parent = parent.parentElement;
    }

    return null;
};
